module.exports = __webpack_public_path__ + "img/22-s.bbff7c54.png";